module.exports = __webpack_public_path__ + "img/ffb774188411aebbdcfb9f76851653f2.svg";